module.exports = __webpack_public_path__ + "static/img6-b9cc95af9a0ad72af3bf7bc90eda36b6.png";